export { default } from './HaveQuestionsView';



// WEBPACK FOOTER //
// ./src/components/views/HaveQuestionsView/index.js